<div class="page-root">
  <div class="page-controls">
    <div class="page-header">
        <!-- Filterleiste für Sender -->
        <div class="channel-filter-bar">
            <img *ngFor="let channel of availableChannels" [src]="getIconFilename({ channel: channel })"
                class="channel-filter-icon" [class.selected]="selectedChannels.includes(channel)"
                (click)="toggleChannel(channel)"
                [title]="selectedChannels.includes(channel) ? channel : channel+' ausgeblendet'" />

            <!-- Alle deaktivieren -->
            <button class="btn btn-outline btn-sm" (click)="deactivateAllFilters()">
                <cds-icon shape="minus-circle" class="is-solid"></cds-icon> Alle deaktivieren
            </button>

            <!-- Alle aktivieren -->
            <button class="btn btn-outline btn-sm" (click)="activateAllFilters()">
                <cds-icon shape="plus-circle" class="is-solid"></cds-icon> Alle aktivieren
            </button>
        </div>
    </div>

    <div class="header-title">
        <h3 *ngIf="fromDate && toDate">
            Statistiken vom {{ fromDate | date: 'dd.MM.yyyy':'UTC' }}
            bis {{ toDate | date: 'dd.MM.yyyy':'UTC' }}
        </h3>
    </div>

    <div class="header-actions">
        <!-- 1. Zeitraum-Typ auswählen -->
        <clr-select-container>
            <label>Zeitraum</label>
            <select clrSelect [(ngModel)]="periodType" (ngModelChange)="onPeriodTypeChange($event)">
                <option value="year">Jahr</option>
                <option value="month">Monat</option>
                <option value="day">Tag</option>
            </select>
        </clr-select-container>

        <!-- 2. Detail-Auswahl je nach Typ -->
        <ng-container [ngSwitch]="periodType">

            <!-- Jahr -->
            <div *ngSwitchCase="'year'" class="period-input">
                <label>Jahr</label>
                <input type="number" class="clr-input" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)"
                    min="2000" max="2100" />
            </div>

            <!-- Monat -->
            <div *ngSwitchCase="'month'" class="period-input">
                <label>Jahr</label>
                <input type="number" class="clr-input" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)"
                    min="2000" max="2100" />

                <label class="period-input-label-gap">Monat</label>
                <select class="clr-input" [(ngModel)]="selectedMonth" (ngModelChange)="onMonthChange($event)">
                    <option [ngValue]="1">01</option>
                    <option [ngValue]="2">02</option>
                    <option [ngValue]="3">03</option>
                    <option [ngValue]="4">04</option>
                    <option [ngValue]="5">05</option>
                    <option [ngValue]="6">06</option>
                    <option [ngValue]="7">07</option>
                    <option [ngValue]="8">08</option>
                    <option [ngValue]="9">09</option>
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="11">11</option>
                    <option [ngValue]="12">12</option>
                </select>
            </div>

            <!-- Tag -->
            <div *ngSwitchCase="'day'" class="period-input">
                <clr-date-container>
                    <label>Tag wählen</label>
                    <input type="date" clrDate [(ngModel)]="selectedDate" (ngModelChange)="onDateChange($event)"
                        placeholder="Datum wählen" />
                </clr-date-container>
            </div>

        </ng-container>
    </div>

    <!-- Tabs: ein Transkriptionsmodell pro Tab. Statische Clarity-Tab-Markup
         statt <clr-tabs>, damit beide Tabs am Leben bleiben und ein Wechsel
         keine erneute Abfrage über alle Tage auslöst. -->
    <ul class="nav statistics-tabs" role="tablist">
        <li role="presentation" class="nav-item">
            <button class="btn btn-link nav-link" role="tab" type="button"
                    [class.active]="activeTab === 'whisper'"
                    [attr.aria-selected]="activeTab === 'whisper'"
                    (click)="selectTab('whisper')">Whisper</button>
        </li>
        <li role="presentation" class="nav-item">
            <button class="btn btn-link nav-link" role="tab" type="button"
                    [class.active]="activeTab === 'voxtral'"
                    [attr.aria-selected]="activeTab === 'voxtral'"
                    (click)="selectTab('voxtral')">Voxtral</button>
        </li>
    </ul>
  </div>

  <app-whisper-statistics [range]="range" [active]="activeTab === 'whisper'"
                          [hidden]="activeTab !== 'whisper'" role="tabpanel" />

  <app-voxtral-statistics [range]="range" [active]="activeTab === 'voxtral'"
                          [hidden]="activeTab !== 'voxtral'" role="tabpanel" />
</div>
